module.exports = __webpack_public_path__ + "static/media/media.717a50f4.svg";